import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {crudifyMutations, resetResults} from 'src/utilities/vuex2'
import Vue from 'vue'
import {OK} from 'http-status-codes'
import {kvps} from 'src/utilities/utils'

const initialState = {
  results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.kvpsForSelect = (state) => {
  return kvps(state.results, 'id', 'city')
}

const mutations = make.mutations(state)
mutations.resetResults = resetResults
crudifyMutations(mutations)

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({state}) {
      const response = await ptracGetEntities('service-areas?sort=city&city.dir=asc')
      if (OK === response.status) {
        state.results = response.data
      }
    }
  }
}
